"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

const REDDIT_PIXEL_ID = process.env.NEXT_PUBLIC_REDDIT_PIXEL_ID?.trim();
const ESCAPED_REDDIT_PIXEL_ID = REDDIT_PIXEL_ID
  ? JSON.stringify(REDDIT_PIXEL_ID)
  : '""';

declare global {
  interface Window {
    rdt?: (...args: unknown[]) => void;
  }
}

export function RedditPixel() {
  const pathname = usePathname();
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (!REDDIT_PIXEL_ID) return;

    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    if (typeof window !== "undefined" && window.rdt) {
      window.rdt("track", "PageVisit");
    }
  }, [pathname]);

  if (!REDDIT_PIXEL_ID) {
    return null;
  }

  return (
    <Script
      id="reddit-pixel-init"
      strategy="lazyOnload"
    >
      {`!function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js?pixel_id="+${ESCAPED_REDDIT_PIXEL_ID};t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);rdt('init',${ESCAPED_REDDIT_PIXEL_ID});rdt('track','PageVisit');`}
    </Script>
  );
}
